import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
} from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs/Observable";
import { tap } from "rxjs/operators";
import { Util } from "../base/util";
import { AuthProvider } from "../auth/auth";
import { Events } from "ionic-angular";

const DEFAULT_HEADER_AUTHORIZATION = "Authorization";
const DEFAULT_HEADER_PREFIX_BEARER = "Bearer";
const DEFAULT_HEADER_ACCEPT = "Accept";
const DEFAULT_HEADER_JSON_APPLICATION = "application/json";

@Injectable()
export class InterceptedHttpProvider implements HttpInterceptor {
  constructor(public util: Util, private events: Events) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    let authReq = req.clone({
      headers: req.headers.set(
        DEFAULT_HEADER_ACCEPT,
        DEFAULT_HEADER_JSON_APPLICATION
      ),
    });

    if (!req.headers.has(DEFAULT_HEADER_AUTHORIZATION)) {
      let autenticado = AuthProvider.autenticado();
      if (autenticado) {
        authReq = req.clone({
          headers: req.headers.set(
            DEFAULT_HEADER_AUTHORIZATION,
            DEFAULT_HEADER_PREFIX_BEARER +
              " " +
              AuthProvider.getAccessTokenString()
          ),
        });
      }
    }
    return next.handle(authReq).pipe(
      tap(
        (event) => {
          if (event instanceof HttpResponse) {
          }
        },
        (err) => {
          let error = err.error;
          let text = "";
          switch (err.status) {
            case 400:
              break;
            case 422:
              for (const i in error.errors) {
                for (const c in error.errors[i]) {
                  //text += `<b>${i}:</b> ${error.errors[i][c]}<br>`;
                  text = `${error.errors[i][c]}<br><br>`;
                }
              }
              this.util.criarAlert("Informativo!", text, "ok");
              break;
            case 401:
              if (AuthProvider.autenticado()) {
                AuthProvider.deslogar();
                this.events.publish("unauthorized:requestError");
              }
              break;
            case 408:
              AuthProvider.deslogar();
              this.events.publish("timeout:requestError");
              break;
            case 404:
              AuthProvider.deslogar();
              this.events.publish("notFound:requestError");
              break;
          }
        }
      )
    );
  }
}



// WEBPACK FOOTER //
// ./src/providers/intercepted-http/intercepted-http.ts